import * as React from "react";
import Navigation from "./Navigation";

const NavigationContext = React.createContext<Navigation | null>(null);
export default NavigationContext;
